import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { GetCurrentDateInJalai } from 'utils/GetCurrentDateInJalai';

const useFilter = () => {
  const IdPerson =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.IdPerson;

  const [filterData, setFilter] = useState({
    idPerson: IdPerson,
    fromDate: GetCurrentDateInJalai(),
    toDate: GetCurrentDateInJalai(),
    noeTarikh: 0,
    noeTaeed: '',
    searchType: 0,
    namePatient: '',
    familyPatient: '',
    ShomareDarkhast: '',
    ShomareParvande: '',
    idPato: '',
    roozMandeTaJavabdehi: -1,
    topRecord: 20,
    idPatient: 0,
  });

  return { filterData, setFilter };
};

export default useFilter;
